import type { IconType } from "@circle-react-shared/Icon";

import { LinkItem } from "../CollapsedSidebar/LinkItem";

interface NavGroupIconProps {
  icon: IconType;
  label: string;
  path: string;
}

export const NavGroupIcon = ({ label, path, icon }: NavGroupIconProps) => (
  <LinkItem label={label} path={path} icon={icon} />
);
